/** Interface strings of the operator audit log (read through useAuditT). */
export const adminAuditMessages = {
  "admin.denied.audit": {
    ru: "Для журнала аудита нужно разрешение audit.read.",
    en: "The audit log needs the audit.read permission.",
  },
  "admin.audit.title": { ru: "Журнал аудита", en: "Audit log" },
  "admin.audit.pick": {
    ru: "Выберите событие, чтобы увидеть детали.",
    en: "Pick an event to see its details.",
  },
  "admin.audit.empty": {
    ru: "Событий по этим фильтрам нет.",
    en: "No events match these filters.",
  },
  "admin.audit.loading": { ru: "Загрузка событий", en: "Loading events" },
  "admin.audit.failed": {
    ru: "Не удалось загрузить журнал аудита.",
    en: "Could not load the audit log.",
  },
  "admin.audit.detailFailed": {
    ru: "Не удалось загрузить событие.",
    en: "Could not load the event.",
  },
  "admin.audit.notFound": { ru: "Событие не найдено.", en: "Event not found." },
  "admin.audit.loadMore": { ru: "Показать ещё", en: "Load more" },
  "admin.audit.back": { ru: "К журналу", en: "Back to the log" },
  "admin.audit.list.caption": { ru: "События аудита", en: "Audit events" },
  "admin.audit.filters": { ru: "Фильтры", en: "Filters" },
  "admin.audit.filters.apply": { ru: "Применить", en: "Apply" },
  "admin.audit.filters.reset": { ru: "Сбросить", en: "Reset" },
  "admin.audit.filter.period": { ru: "Период", en: "Period" },
  "admin.audit.period.24h": { ru: "24 ч", en: "24 h" },
  "admin.audit.period.7d": { ru: "7 дн", en: "7 d" },
  "admin.audit.period.30d": { ru: "30 дн", en: "30 d" },
  "admin.audit.period.all": { ru: "Всё", en: "All" },
  "admin.audit.filter.type": { ru: "Тип события", en: "Event type" },
  "admin.audit.filter.operator": { ru: "Оператор (id)", en: "Operator (id)" },
  "admin.audit.filter.user": { ru: "Пользователь (id)", en: "User (id)" },
  "admin.audit.filter.outcome": { ru: "Результат", en: "Outcome" },
  "admin.audit.filter.any": { ru: "Любой", en: "Any" },
  "admin.audit.filter.invalid": {
    ru: "Некорректный фильтр. Проверьте значения.",
    en: "Invalid filter. Check the values.",
  },
  "admin.audit.filter.invalidId": {
    ru: "Нужен идентификатор в формате UUID.",
    en: "A UUID identifier is required.",
  },
  "admin.audit.filter.invalidCursor": {
    ru: "Страница устарела, обновите список.",
    en: "The page expired, refresh the list.",
  },
  "admin.audit.field.eventType": { ru: "Тип события", en: "Event type" },
  "admin.audit.field.eventId": { ru: "Идентификатор", en: "Event id" },
  "admin.audit.field.occurredAt": { ru: "Время", en: "Time" },
  "admin.audit.field.actor": { ru: "Исполнитель", en: "Actor" },
  "admin.audit.field.resource": { ru: "Объект", en: "Resource" },
  "admin.audit.field.outcome": { ru: "Результат", en: "Outcome" },
  "admin.audit.field.reason": { ru: "Причина", en: "Reason" },
  "admin.audit.field.correlation": { ru: "Корреляция", en: "Correlation" },
  "admin.audit.field.causation": {
    ru: "Причинное событие",
    en: "Causation",
  },
  "admin.audit.field.idempotency": {
    ru: "Ключ идемпотентности",
    en: "Idempotency ref",
  },
  "admin.audit.field.schemaVersion": {
    ru: "Версия схемы",
    en: "Schema version",
  },
  "admin.audit.field.summary": { ru: "Сводка", en: "Summary" },
  "admin.audit.summary.empty": { ru: "Сводка пуста.", en: "No summary." },
  "admin.audit.outcome.success": { ru: "Успешно", en: "Success" },
  "admin.audit.outcome.denied": { ru: "Отказано", en: "Denied" },
  "admin.audit.outcome.failure": { ru: "Ошибка", en: "Failure" },
  "admin.audit.actor.other": {
    ru: "Система или пользователь",
    en: "System or user",
  },
  "admin.audit.openUser": { ru: "Открыть пользователя", en: "Open user" },
  "admin.audit.openLogs": { ru: "Открыть в логах", en: "Open in logs" },
  "admin.audit.openOperator": { ru: "Открыть оператора", en: "Open operator" },
  "admin.audit.copy": { ru: "Скопировать", en: "Copy" },
  "admin.audit.copied": { ru: "Скопировано", en: "Copied" },
  "admin.audit.type.operator.session.v1": {
    ru: "Сессия оператора",
    en: "Operator session",
  },
  "admin.audit.type.authorization.denied.v1": {
    ru: "Отказ в доступе",
    en: "Authorization denied",
  },
  "admin.audit.type.administration.command.v1": {
    ru: "Команда администратора",
    en: "Admin command",
  },
  "admin.audit.type.account.deletion.v1": {
    ru: "Удаление аккаунта",
    en: "Account deletion",
  },
  "admin.audit.type.admin.model_registry.override.v1": {
    ru: "Переопределение модели",
    en: "Model override",
  },
  "admin.audit.type.admin.assistant_feedback.review.v1": {
    ru: "Разбор фидбэка",
    en: "Feedback review",
  },
  "admin.audit.type.admin.assistant_job.inspect.v1": {
    ru: "Просмотр задачи ассистента",
    en: "Assistant job inspected",
  },
  "admin.audit.type.admin.routing_profile.inspect.v1": {
    ru: "Просмотр профиля маршрутизации",
    en: "Routing profile inspected",
  },
  "admin.audit.type.admin.user.inspect.v1": {
    ru: "Просмотр пользователя",
    en: "User inspected",
  },
  "admin.audit.type.admin.trace.inspect.v1": {
    ru: "Просмотр трассы",
    en: "Trace inspected",
  },
  "admin.audit.type.admin.billing.price_changed.v1": {
    ru: "Изменение цены",
    en: "Price changed",
  },
  "admin.audit.type.admin.billing.grant.v1": {
    ru: "Выдача вручную",
    en: "Manual grant",
  },
  "admin.audit.type.admin.operator_access.changed.v1": {
    ru: "Изменение доступа оператора",
    en: "Operator access changed",
  },
  "admin.audit.type.admin.audit.inspect.v1": {
    ru: "Просмотр события аудита",
    en: "Audit event inspected",
  },
  "admin.audit.type.ability_schema.draft_edited.v1": {
    ru: "Черновик схемы изменён",
    en: "Schema draft edited",
  },
  "admin.audit.type.ability_schema.published.v1": {
    ru: "Схема опубликована",
    en: "Schema published",
  },
  "admin.audit.type.ability_schema.draft_discarded.v1": {
    ru: "Черновик схемы отброшен",
    en: "Schema draft discarded",
  },
} as const;

export type AdminAuditMessageKey = keyof typeof adminAuditMessages;
